import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguageStore } from '../../store/languageStore';
import translations from '../../translations';

interface ConfirmationDialogProps {
  type: 'clockin' | 'finishjob' | 'clockout';
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export function ConfirmationDialog({
  type,
  onConfirm,
  onCancel,
  loading,
}: ConfirmationDialogProps) {
  const { language } = useLanguageStore();
  const t = translations[language].timeTracker;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          {type === 'clockin' ? t.confirmations.clockIn.title :
            type === 'finishjob' ? t.confirmations.finishJob.title :
            t.confirmations.clockOut.title}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {type === 'clockin' ? t.confirmations.clockIn.message :
            type === 'finishjob' ? t.confirmations.finishJob.message :
            t.confirmations.clockOut.message}
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            {t.buttons.cancel}
          </button>
          <button onClick={onConfirm} className="btn-primary">
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                {t.buttons.processing}
              </>
            ) : (
              t.buttons.confirm
            )}
          </button>
        </div>
      </div>
    </div>
  );
}